import type { Dispatch, SetStateAction } from 'react';
import { useMemo } from 'react';
import type { ListData } from '../../CustomList/CustomList';
import CustomList from '../../CustomList/CustomList';
import type { Product } from 'components/hooks/MTU';

interface Props {
    isProductTutorial?: boolean,
    products: Product[],
    selectedProduct?: Product,
    setSelectedProductIndex: Dispatch<SetStateAction<number>>
}

interface FormattedProduct extends Product {
    formattedName: string
}

export default function ProductList({ isProductTutorial, products, selectedProduct, setSelectedProductIndex }: Props) {

    const formattedProducts = useMemo(() => {
        return products.map((product) => {
            if (product.localInfoCurrency === 'USD') {
                return {
                    ...product,
                    formattedName: '$' + product.localInfoAmount
                }
            } else {
                return {
                    ...product,
                    formattedName: product.localInfoAmount + ' ' + product.localInfoCurrency
                }
            }
        });
    }, [products])

    const handleProductChange = async (product: FormattedProduct & ListData, index: number) => {
        setSelectedProductIndex(index);
    }

    return (
        <CustomList
            selectedId={selectedProduct?.retailPrice}
            id='retailPrice'
            display='formattedName'
            title='SEARCH PRODUCT'
            data={formattedProducts}
            tooltip={
                <>
                    <div>SELECT A PRICE POINT</div>
                </>
            }
            tooltipShown={isProductTutorial}
            className={isProductTutorial ? 'Focused' : ''}
            autoFocus={isProductTutorial}
            onChange={handleProductChange} />
    );
}